<template>
  <div class="returned-value-box pt-3 pb-4" :class="{ innerElement: innerElement }">
    <div class="mb-0">{{ text }}<b><span class="text-primary">£{{ formatNumberOutput(value) }}</span></b></div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    value: Number,
    innerElement: Boolean
  },
  methods: {
    formatNumberOutput(number) {
      const newNumber = (new Intl.NumberFormat('en-GB').format(number))
      if ( newNumber === 'NaN' ) { return 0 } return newNumber
    }
  }
}
</script>

<style lang="scss" scoped>
.innerElement {
  margin-top: -3rem;
}
</style>